import type { Article } from '@seek/cmsu-cms-connect';
import { Box, Divider, Link, Stack, Text } from 'braid-design-system';
import React from 'react';
import { interactive } from './styles.css';
import { defaultArticleItemFieldVisibility } from '../ArticleItem/ArticleItem';
import type { ArticleItemFieldVisibility } from '../ArticleItem/articleItemHelper';
import { ArticleItemFooter } from '../ArticleItemFooter/ArticleItemFooter';
import { ArticleItemCategory } from '../ArticleItemCategory/ArticleItemCategory';

type Props = {
  article: Article;
  articleLink: string;
  fieldVisibility?: ArticleItemFieldVisibility;
  isLastItem?: boolean;
};

export const ArticleListItem = ({
  article,
  articleLink,
  fieldVisibility = defaultArticleItemFieldVisibility(),
  isLastItem = false,
}: Props) => (
  <Stack space="gutter">
    <Box
      borderRadius="large"
      display="flex"
      style={{
        gap: '24px',
      }}
    >
      <Box
        data={{ testid: 'ArticleFeatureImageTestId' }}
        component="img"
        src={article.featureImage[0]?.url}
        style={{
          width: '200px',
          borderRadius: '6px',
        }}
      />
      <Box
        display="flex"
        justifyContent="spaceBetween"
        flexDirection={'column'}
        padding={{ mobile: 'gutter', tablet: 'none' }}
      >
        <Box paddingBottom="large">
          <Stack space="gutter">
            <ArticleItemCategory
              article={article}
              fieldVisibility={fieldVisibility}
            />

            <Link href={articleLink} className={interactive}>
              <Text size="large" weight="strong">
                {article.title}
              </Text>
            </Link>

            {fieldVisibility.showExcerpt && Boolean(article.excerpt) && (
              <Text size="standard" data={{ testid: 'ArticleExcerptTestId' }}>
                {article.excerpt}
              </Text>
            )}
          </Stack>
        </Box>
        <ArticleItemFooter
          article={article}
          fieldVisibility={fieldVisibility}
        />
      </Box>
    </Box>

    {!isLastItem && <Divider weight="regular" />}
  </Stack>
);
